import { IMAGE_DESKTOP, IMAGE_MOBILE, ICON_FIELD } from '../elements/assets'
import { LINK_TITLE } from '../elements/link'

export const USE_CASES_SLIDER = `
...on useCasesSlider_Entry {
  id
  typeHandle
  headingAdvanced {
    html
  }

  cards: useCasesSliderMatrix {
    id
    ${ ICON_FIELD }
    iconTitle

    headingAdvanced {
      html
    }

    ${ LINK_TITLE }

    ${ IMAGE_MOBILE }
    ${ IMAGE_DESKTOP }
  }
}
`